export default "__VITE_ASSET__HZwy2$1H__"